import { PixelRatio, Platform, useWindowDimensions } from "react-native";
import { isTelevisionRuntime } from "./platformCapabilities";

export function getReferenceViewportScale() {
  // Android TV can report Platform.OS as "android" and expose its TV
  // identity through uiMode instead of Platform.isTV. Keep the web preview
  // in CSS pixels, but give native TV builds the same viewing-distance scale.
  if (Platform.OS === "web" || !isTelevisionRuntime()) return 1;
  return Math.max(1, PixelRatio.get());
}

export function useReferenceWindowDimensions() {
  const dimensions = useWindowDimensions();
  const referenceScale = getReferenceViewportScale();
  return {
    ...dimensions,
    width: dimensions.width * referenceScale,
    height: dimensions.height * referenceScale,
    referenceScale,
    nativeWidth: dimensions.width,
    nativeHeight: dimensions.height,
  };
}
